import { connect } from "react-redux";
import values from "lodash/values";
import {
	setProductsFilter,
	unsetProductsFilter,
} from "app/pages/Listing/ProductFilters/productsFilterActionCreators";
import { bindActionCreators } from "redux";
import ProductsFilter from "app/pages/Listing/ProductFilters/ProductsFilter";
import {
	getMerchandisingBadgeFilterValues,
	getMerchandisingDestinationFilterValues,
	getMerchandisingMonthFilterValues,
	getMerchandisingSelectedFacets,
	getMerchandisingTopicFilterValues,
	getMerchandisingVisibleFilters,
	shouldDisplayDestinationFilter,
} from "app/pages/Merchandising/merchandisingSelector";

const mapStateToProps = state => {
	return {
		productsFilters: state.productsFilters,
		productsActiveFilters: values(state.productsFilters),
		visibleFilters: getMerchandisingVisibleFilters(state),
		selectedFacets: getMerchandisingSelectedFacets(state),
		destinationFilterValues: getMerchandisingDestinationFilterValues(state),
		topicFilterValues: getMerchandisingTopicFilterValues(state),
		monthsFilterValues: getMerchandisingMonthFilterValues(state),
		badgesFilterValues: getMerchandisingBadgeFilterValues(state),
		displayDestinationFilter: shouldDisplayDestinationFilter(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ setProductsFilter, unsetProductsFilter }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductsFilter);
